import React, { Component } from "react";
import Bio from "./bio";
import PlayerAction from "./playerAction";
import PlayerShortStats from "./PlayerShortStats";
import Advertisement from "./advertisement";
import PlayerGraph from "./playerGraph";
import Fixtures from "./fixtures";
import PlayerStatsByMatchDay from "./playerStatsByMatchDay";
import PlayerStatsSeason from "./playerStatsSeason";
import StatusComponent from "./statusComponent";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import { Scrollbars } from "react-custom-scrollbars";
import { calculatePercentile, makeClasses } from "./helper";
import { isEmpty, find } from "lodash";
import OutsideNotifier from "../OutsideNotifier";
import config from "../../common/config";
import {
  LiveScoringContext,
  LoginContext,
  TeamDataContext,
  CompositionContext,
  GamedaysContext,
  ShowToastContext,
  PlayerListContext,
  FixturesContext,
} from "../../Context";
import { Consume } from "../../Context/Consumer";
import { withRouter } from "react-router-dom";
import { getCurrMd, showLoader, hideLoader } from "./helper";
import {
  createModified,
  customTracking,
  getLivePlayerDetails,
  getLoginCookie,
  getUserProfile,
  makeManageTeamSkeleton,
  setLocalStorage,
  virPathTracking,
} from "../../common";
import CardFixStrip from "./CardFixStrip";
import Loader from "../Loader";
import apiErrors from "../../common/api-errors";

class PlayerCardPopup extends Component {
  constructor(props) {
    super(props);
    // this.autoComplete.bind(this)
    this.state = {
      scrollTop: 0,
      playerDetailsObj: {},
      currMatchDay: {},
      showPtsSysTooltip: false,
      rawMatchDay: this.props.currMatchDay,
      isComponentloaded: false,
      animationDone: false,
      addHeaderclass: false,
      isHeaderclass: false,
      showWarning: false,
    };
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  onGraphClick = (matchday) => {
    const { playerCardActions } = this.props;

    // let pageName = "";
    // if (window.location.pathname.indexOf("my-team") > -1) {
    //   pageName = "/" + config.GAME_NAME + "/my-team/manage/";
    // } else if (window.location.pathname.indexOf("manage-team") > -1) {
    //   pageName = "/" + config.GAME_NAME + "/my-team/transfers/";
    // } else if (window.location.pathname.indexOf("create-team") > -1) {
    //   pageName = "/" + config.GAME_NAME + "/create-team/";
    // } else if (window.location.pathname.indexOf("overview") > -1) {
    //   pageName = "/" + config.GAME_NAME + "/home";
    // }
    // customTracking(
    //   "Select " + "Matchday" + matchday.mdId + " - player card",
    //   pageName
    // );

    let filFix = playerCardActions.playerDetail.Fixtures.filter((f) => {
      return f.MatchId === matchday.MatchId;
    });

    let filFixPoints = playerCardActions.playerDetail.GamedayPoints.filter(
      (f) => {
        return f.MatchId === matchday.MatchId;
      }
    );

    let filFixStats = playerCardActions.playerDetail.GamedayStats.filter(
      (f) => {
        return f.MatchId === matchday.MatchId;
      }
    );

    let selectedFixture = {
      ...matchday,
      ...filFix[0],
      GamedayPoints: filFixPoints[0] || {},
      GamedayStats: filFixStats[0] || {},
    };

    this.setState({
      currMatchDay: selectedFixture,
    });
  };

  setShowWarning = (toggle) => {
    let self = this;
    self.setState({
      showWarning: toggle,
    });
  };

  handleUpdate(values) {
    const { scrollTop } = values;
    const playerInfoHeader =
      document.getElementsByClassName("si-plyr__head")[0];

    if (playerInfoHeader) {
      if (scrollTop > 20) {
        this.setState({
          addHeaderclass: true,
        });
        playerInfoHeader.classList.add(
          "si-small-header",
          "si-on-scroll-gradient",
          "si-head__small"
        );
      } else {
        this.setState({
          addHeaderclass: false,
        });
        playerInfoHeader.classList.remove(
          "si-small-header",
          "si-on-scroll-gradient",
          "si-head__small"
        );
      }
    }
    if (scrollTop !== this.state.scrollTop) {
      this.setState({ scrollTop });
    }
  }

  init = () => {
    //make api call
    let self = this;
    let { player, getPlayerDetail } = self.props.playerCardActions;
    let { screenMode, mode, gamedays, LiveScoringData } = self.props;
    let playerID = "";
    if (player.id) {
      playerID = player.id;
    } else if (player.DBDetails && player.DBDetails.id) {
      playerID = player.DBDetails.id;
    } else if (player.details) {
      playerID = player.details.id;
    } else {
      playerID = null;
    }

    getPlayerDetail(
      {
        playerId: player.id
          ? player.id
          : player.DBDetails.Id
          ? player.DBDetails.Id
          : player,
      },
      (value) => {
        if (LiveScoringData.scoring) {
          let { isPlayerLive, livePlayerDetails } =
            LiveScoringData?.scoring !== null &&
            getLivePlayerDetails(value.Id, LiveScoringData.scoring);
          if (isPlayerLive) {
            value.GamedayPoints.push(livePlayerDetails.GamedayPoints);
            value.GamedayStats.push(livePlayerDetails.GamedayStats);
            value.isLive = true;
          }
        }
        let bio = player.details ? player.details : player;
        if (!isEmpty(player.details)) {
          bio = player.details;
        } else if (
          player.DBDetails &&
          player.DBDetails.Id &&
          (screenMode == config.screenMode.substitution ||
            screenMode == config.screenMode.transfer)
        ) {
          bio = player.DBDetails;
        } else {
          bio = player;
        }
        let playerDetailsObj = {
          ...value,
          ...{ bio: bio },
          ...{ modifiedData: value.Fixtures },
          ...{ rawDBDeatails: player.DBDetails },
        };
        //chekc the match day
        // mode
        let isInSubsMode = false;
        let mdFromMatchDetails = self.props.playerCardActions.specificData
          .matchDetailsSelectedMd
          ? self.props.playerCardActions.specificData.matchDetailsSelectedMd
          : 0;
        let mdIdSelcted =
          mdFromMatchDetails || self.props.currMatchDay.GamedayId;

        let filFix = value.Fixtures.filter((f) => {
          return f.GamedayId === self.props.currMatchDay.GamedayId;
        });

        let filFixPoints = value.GamedayPoints.filter((f) => {
          return f.GamedayId === self.props.currMatchDay.GamedayId;
        });

        let filFixStats = value.GamedayStats.filter((f) => {
          return f.GamedayId === self.props.currMatchDay.GamedayId;
        });

        let selectedFixture = {
          ...self.props.currMatchDay,
          ...filFix[0],
          GamedayPoints: filFixPoints[0] || {},
          GamedayStats: filFixStats[0] || {},
        };

        self.setState({
          playerDetailsObj: playerDetailsObj,
          currMatchDay: filFix.length
            ? selectedFixture
            : createModified(value.Fixtures, self.props.playerCardActions),
        });
        self.setState({
          isComponentloaded: true,
        });
      },
      () => {
        //no player id recived
        clearAllBodyScrollLocks();
      }
    );
  };
  componentDidMount() {
    let self = this;
    self.init();
  }

  componentDidUpdate(prevProps, prevState) {
    // let { playerDetailsObj, currMatchDay } = prevState;
    // let { playerScoring } = this.props.Live;
    // let liveFix = {};
    //modify player details in case of live
    // if (!isEmpty(playerDetailsObj) && playerScoring) {
    //     if (!isEmpty(playerDetailsObj.modifiedData)) {
    //         let fixtures = playerDetailsObj.modifiedData;
    //         liveFix = fixtures.find((fix) => { return fix.mId == playerScoring.mId })
    //     }
    //     //if mdidis different
    //     if (!isEmpty(liveFix)) {
    //         if (currMatchDay.mdId != liveFix.mdId) {
    //             // this.setState({
    //             //     currMatchDay: liveFix
    //             // })
    //         }
    //     }
    // }
  }

  setClosingAnimation = () => {
    this.setState({
      isComponentloaded: false,
    });
  };
  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  onPtsSysIconClick = () => {
    if (this.props.mode == config.modes.live) {
      this.props.playerCardClose();
    }
    const showTooltip = this.state.showPtsSysTooltip;
    if (!showTooltip) {
      this.setState({ showPtsSysTooltip: true });
    } else {
      this.setState({ showPtsSysTooltip: false });
    }
    clearAllBodyScrollLocks();
    this.props.playerCardActions.showHidePlyrCard();
    let articleId = config.WebConfig.rules;
    if (articleId) {
      this.props.history.push("/info/" + articleId + "/rules");
      // this.props.onRedirectTo(('/info/' + articleId + "/0"), '')
    }
  };

  getLiveTeamScore(selectedFixture, playerScoring) {
    let { scoreLine } = playerScoring;
    let htScore = 0,
      atScore = 0;
    if (scoreLine && scoreLine.length) {
      scoreLine.forEach((sl) => {
        if (sl.tId == selectedFixture.htId) {
          htScore = sl.gS;
        } else {
          atScore = sl.gS;
        }
      });
    }
    return { htScore, atScore };
  }

  showHidePlyrCard = () => {
    if (this.props.playerCardClose) {
      this.props.playerCardClose();
    }
    this.props.playerCardActions.showHidePlyrCard();
  };

  makeCaptainHelper = (player) => {
    const loginCookie = getLoginCookie();
    const {
      TeamData,
      CompositionData,
      Gamedays,
      PlayerListData,
      getTrans,
      teamData: teamDataParent,
      trans,
      FixturesData,
      showHideToast,
    } = this.props;

    const { makePostCaptain } = TeamData;

    let paramsCap = {
      optType: config.optType,
      platform: 1,
      gamedayId: FixturesData.currMatchDay.GamedayId,
      phaseId: FixturesData.currMatchDay.PhaseId,
      teamName: loginCookie.TeamName,
      captainId: player.id,
      gdCompId:
        CompositionData.data[config.WebConfig.MAX_FORMATION_COMP_ID].CompId,
      mdCompId: teamDataParent.CompId,
      bsCaptainId: teamDataParent.boosterCaptainId,
    };
    makePostCaptain(
      paramsCap,
      (resp) => {
        this.showHidePlyrCard();
        showHideToast(
          true,
          getTrans(trans, "cptChange", "captain change successfull"),
          false
        );

        let params = {
          optType: config.optType,
          gamedayId: FixturesData.currMatchDay.GamedayId,
          phaseId: FixturesData.currMatchDay.PhaseId,
          language: config.language,
        };
        Gamedays.getSelectedTeam(
          params,
          (response) => {
            let teamDataSkeleton = makeManageTeamSkeleton(
              response.Data.Value,
              PlayerListData.rawPlayerList,
              CompositionData.data
            );
            TeamData.setTeamData({
              ...teamDataSkeleton.teamData,
            });
            setLocalStorage("teamData", teamDataSkeleton.teamData);
          },
          () => {}
        );
      },
      (resp) => {
        this.showHidePlyrCard();

        if (resp) {
          let retVal = resp.RetVal;
          let success = resp.Success;

          console.log(retVal);
          console.log({ msg: apiErrors.captainChange[retVal] });
          if (!success) {
            showHideToast(true, apiErrors.captainChange[retVal], false);
          } else {
            // self.showHideToast(true, `retVal Error ${retVal}`, true);
            // self.resetTeam(true);
          }
        }
      }
    );
  };

  render() {
    let { playerIndex, playerActions, specificData } =
      this.props.playerCardActions;
    let {
      playerDetailsObj,
      currMatchDay,
      rawMatchDay,
      addHeaderclass,
      showWarning,
    } = this.state;
    let {
      config,
      getTrans,
      trans,
      addRemPly,
      teamData,
      makeCaptain,
      mode,
      teamDataActions,
      compositions,
      screenMode,
      playerCardClose,
      gamedays,
      blockAction,
    } = this.props;
    let { scoring } = this.props.LiveScoringData;
    let { showHidePlyrCard, makeCaptainHelper } = this;
    let player = null;
    let isLiveMatch = false; //to check the player pop up should show points after logging  lateonboard user
    //modify player details in case of live
    if (
      !isEmpty(playerDetailsObj.modifiedData) &&
      scoring &&
      scoring.livePoints &&
      scoring.livePoints.pId == playerDetailsObj.id
    ) {
      if (!isEmpty(playerDetailsObj.modifiedData) && scoring && scoring.mId) {
        let fixtures = playerDetailsObj.modifiedData;
        let liveFix = fixtures.find((fix) => {
          return (
            fix.GD_IsCurrent == 1 && fix.GD_IsLocked && fix.MatchStatus == 1
          );
        });

        if (liveFix) {
          isLiveMatch = true;
          let { htScore, atScore } = this.getLiveTeamScore(liveFix, scoring);
          liveFix.matchStatus = "1";
          liveFix.isPlayerLive = true;
          liveFix.phase = scoring.phase;
          liveFix.status = scoring.status;
          liveFix.stats = scoring.liveStats;
          liveFix.points = scoring.livePoints;
          liveFix.htScore = htScore;
          liveFix.atScore = atScore;
          liveFix.liveMinutes = scoring.minuteString;

          let isLive = scoring.liveStats && scoring.livePoints ? true : false;
          playerDetailsObj.modifiedData = calculatePercentile(
            playerDetailsObj,
            isLive
          );
        }
      }
    }
    //end

    const showTooltip = this.state.showPtsSysTooltip;

    let animationClass = makeClasses({
      "si-plyr__card si-active": this.state.isComponentloaded,
      "si-plyr__card  si-fade-out": !this.state.isComponentloaded,
    });

    if (/* !isEmpty(playerDetailsObj) */ true) {
      hideLoader();
      player = playerDetailsObj.bio;
      let headingText = getTrans(
        trans,
        "upcomingFixtures",
        "Fixtures & Results"
      );

      const cardParams = {
        matchDays: playerDetailsObj.Fixtures,
        playerDetailsObj,
        currMatchDay,
        config,
        getTrans,
        trans,
        isLiveMatch,
        player,
        onGraphClick: this.onGraphClick,
        screenMode,
        mode,
      };

      if (!playerDetailsObj.Fixtures) {
        return (
          <Loader style={{ background: "rgba(0,0,0,0.7)" }} />
          // <div>Loading</div>
        );
      }

      return showWarning ? (
        <div className="si-popup__wrap si-league__popup si-fade in">
          <div className="si-popup__container">
            <div className="si-popup__head">
              <div
                className="si-popup__close"
                onClick={() => {
                  showHidePlyrCard();
                }}
              >
                <div className="si-btn__adRe"></div>
              </div>
            </div>
            <div className="si-popup__body">
              <div className="si-popup__para">
                <span>
                  {getTrans(
                    trans,
                    "confirmCaptainBrief",
                    "You’ll lose bonus points scored by your current captain and won’t be able to reappoint them this matchday."
                  )}
                </span>
              </div>
            </div>
            <div className="si-popup__foot">
              <div
                className="si-btn si-btn__primary si-btn__primary--outline"
                onClick={() => {
                  showHidePlyrCard();
                }}
              >
                <span>{getTrans(trans, "cancel", "Cancel")}</span>
              </div>
              <div
                className="si-btn si-btn__primary"
                onClick={() => {
                  makeCaptainHelper(this.props.playerCardActions.player);
                }}
              >
                <span>{getTrans(trans, "confirm", "Confirm")}</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="si-popup__wrap si-player__popup si-fade in"
          style={{ zIndex: "1111" }}
        >
          <OutsideNotifier handler={() => showHidePlyrCard()}>
            <div
              className="si-popup__container"
              style={{ maxHeight: "calc(100vh - 100px)" }}
            >
              <div className="si-popup__head">
                <Bio
                  showGeneric={specificData.generic}
                  specificdata={specificData}
                  setClosingAnimation={this.setClosingAnimation}
                  close={showHidePlyrCard}
                  teamData={teamData}
                  mode={mode}
                  // closeLiveScore={playerCardClose}
                  player={this.props.playerCardActions.player}
                  // playerDetailsObj={playerDetailsObj}
                  gamedays={gamedays}
                  config={config}
                  getTrans={getTrans}
                  trans={trans}
                  rawMatchDay={rawMatchDay}
                  addHeaderclassName={addHeaderclass}
                  showHidePlyrCard={showHidePlyrCard}
                ></Bio>
                <CardFixStrip {...cardParams} />
              </div>

              <div
                className="si-popup__body"
                style={{ height: "calc(100vh - 60px)", padding: 0 }}
              >
                <Scrollbars className="si-scroll_js">
                  <div className="si-player__body" style={{ padding: "10px" }}>
                    <div className="si-player__fixtures">
                      <div className="si-fixtures__box">
                        <ul>
                          <li>
                            <Fixtures {...cardParams} />
                          </li>
                        </ul>
                      </div>

                      <PlayerStatsByMatchDay {...cardParams} />
                    </div>
                  </div>
                </Scrollbars>
              </div>

              {!blockAction && (
                <div className="si-popup__foot">
                  {specificData.showActionButtons ? (
                    <PlayerAction
                      compositions={compositions}
                      teamDataPlayer={this.props.playerCardActions.player}
                      player={this.props.playerCardActions.player}
                      playerActions={playerActions}
                      specificData={specificData}
                      addRemPly={addRemPly}
                      makeCaptain={makeCaptain}
                      playerIndex={playerIndex}
                      config={config}
                      close={showHidePlyrCard}
                      teamData={teamData}
                      getTrans={getTrans}
                      trans={trans}
                      mode={mode}
                      teamDataActions={teamDataActions}
                      screenMode={screenMode}
                      showHideToast={this.props.showHideToast}
                      setShowWarning={this.setShowWarning}
                    ></PlayerAction>
                  ) : null}
                </div>
              )}
            </div>
          </OutsideNotifier>
        </div>
      );
    }
  }
}

// export default PlayerCardPopup;
export default withRouter(
  Consume(PlayerCardPopup, [
    LiveScoringContext,
    LoginContext,
    TeamDataContext,
    CompositionContext,
    GamedaysContext,
    PlayerListContext,
    FixturesContext,
    ShowToastContext,
  ])
);
